import { EventEmitter, OnDestroy } from '@angular/core';
import { Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-sku-date',
  templateUrl: './sku-date.component.html',
  styleUrls: ['./sku-date.component.scss']
})
export class SkuDateComponent implements OnInit,OnDestroy {
  @Input() expDate: string;
  private destroy$ = new Subject<void>();
  @Output() expDateEvent: EventEmitter<string> = new EventEmitter();
  minDate = new Date();
  control: FormControl = new FormControl()
  constructor() { }

  ngOnInit(): void {
    this.control.setValue(this.expDate, { emitEvent: false });
    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(e => {
      
      this.expDate = new Date(e).toISOString().replace(" ", "T")
      this.expDateEvent.emit(this.expDate)
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
